<div class="app-dialog attach-shipment-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "printCardOrders.attachShipment.title" | translate }}</h2>
      <p class="app-dialog__subtitle">
        {{ "printCardOrders.attachShipment.subtitle" | translate }}
      </p>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body attach-shipment-dialog__body" [formGroup]="form">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
      <mat-label>{{ "printCardOrders.attachShipment.carrier" | translate }}</mat-label>
      <mat-select formControlName="carrier" required>
        <mat-option value="UPS">{{
          "printCardOrders.shipmentCarrierUps" | translate
        }}</mat-option>
        <mat-option value="OTHER">{{
          "printCardOrders.shipmentCarrierOther" | translate
        }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="span-full"
      *ngIf="form.controls.carrier.value === 'OTHER'"
    >
      <mat-label>{{ "printCardOrders.attachShipment.carrierName" | translate }}</mat-label>
      <input matInput formControlName="carrierName" maxlength="120" />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-full">
      <mat-label>{{ "printCardOrders.attachShipment.trackingNumber" | translate }}</mat-label>
      <input
        matInput
        formControlName="trackingNumber"
        [attr.maxlength]="form.controls.carrier.value === 'UPS' ? 40 : 80"
      />
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      subscriptSizing="dynamic"
      class="span-full"
      *ngIf="form.controls.carrier.value === 'OTHER'"
    >
      <mat-label>{{ "printCardOrders.attachShipment.trackingUrl" | translate }}</mat-label>
      <input matInput formControlName="trackingUrl" type="url" maxlength="500" />
      <mat-hint>{{ "printCardOrders.attachShipment.trackingUrlHint" | translate }}</mat-hint>
    </mat-form-field>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()" [disabled]="saving">
      {{ "cancel" | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="submit()"
      [disabled]="saving || form.invalid"
    >
      <mat-spinner class="dc-btn-spinner" diameter="18" *ngIf="saving"></mat-spinner>
      {{ "printCardOrders.attachShipment.save" | translate }}
    </button>
  </footer>
</div>
